module.exports = __webpack_public_path__ + "static/media/phone_2.ea253bde.png";